import $ from 'jquery';

const $window = $(window);
const $loader = $('.loader');

$window.on('loader:show', () => $loader.addClass('loader--active'));
$window.on('loader:hide', () => $loader.removeClass('loader--active'));
